<!-- Navigation to the cm contract behind an event / rate row: skeleton while resolving, disabled with reason on error. -->
@if (loading) {
    <p-skeleton width="9rem" height="2rem"></p-skeleton>
} @else if (loadFailed) {
    <p-button label="Vertrag öffnen"
              icon="fa-regular fa-arrow-up-right-from-square"
              severity="secondary"
              [outlined]="true"
              size="small"
              [disabled]="true"
              pTooltip="Der Vertrag konnte nicht ermittelt werden."
              tooltipPosition="top">
    </p-button>
} @else if (contract) {
    <p-button [label]="'Vertrag ' + contract.contractIdentifier + ' öffnen'"
              icon="fa-regular fa-arrow-up-right-from-square"
              severity="secondary"
              [outlined]="true"
              size="small"
              pTooltip="Öffnet die Vertragsseite (cm)"
              tooltipPosition="top"
              (onClick)="openContract()">
    </p-button>
}
